export class RenderQuickSort {
    sort(elements, isTransparent, left, right) {
        this.elementArray = elements;
        this.isTransparent = isTransparent;
        this._quickSort(left, right);
    }
    _quickSort(left, right) {
        if (this.elementArray.length > 1) {
            const index = this._partitionRenderObject(left, right);
            const leftIndex = index - 1;
            if (left < leftIndex)
                this._quickSort(left, leftIndex);
            if (index < right)
                this._quickSort(index, right);
        }
    }
    _partitionRenderObject(left, right) {
        const elements = this.elementArray.elements;
        const pivot = elements[Math.floor((right + left) / 2)];
        while (left <= right) {
            while (this._compare(elements[left], pivot) < 0)
                left++;
            while (this._compare(elements[right], pivot) > 0)
                right--;
            if (left < right) {
                const temp = elements[left];
                elements[left] = elements[right];
                elements[right] = temp;
                left++;
                right--;
            }
            else if (left === right) {
                left++;
                break;
            }
        }
        return left;
    }
    _compare(left, right) {
        const renderQueue = left.materialRenderQueue - right.materialRenderQueue;
        if (renderQueue === 0) {
            const sort = this.isTransparent ? right.owner.distanceForSort - left.owner.distanceForSort : left.owner.distanceForSort - right.owner.distanceForSort;
            return sort + right.owner.sortingFudge - left.owner.sortingFudge;
        }
        else
            return renderQueue;
    }
}
